import React, { useState, useEffect } from 'react'
import LabeledCalendar from '../../../common/form-components/labeled-calendar/LabeledCalendar'
import LabeledDropdown from '../../../common/form-components/labeled-dropdown/LabeledDropdown'
import { OwnFuelStationsService } from '../../../../services/own-fuel-stations/ownFuelStations.service'

const GasStationChangeDate = ({
  inputs,
  onChangeInputs,
  updateInputs,
  ownStationId,
  ownFuelStationDisabled,
}) => {
  const [fuelStationsOwn, setFuelStationsOwn] = useState([])

  useEffect(() => {
    getFuelStationsOwn()
  }, [])

  const getFuelStationsOwn = async () => {
    const resp = await OwnFuelStationsService.getAll({})
    if (resp) {
      setFuelStationsOwn(resp?.resp)
      if (ownStationId) {
        const getStation = resp?.resp.find((x) => x._id === ownStationId)
        updateInputs({ ...inputs, ownStation: getStation })
      }
    }
  }

  const getMaxDate = () => {
    const today = new Date()
    const maxDate = new Date(today)
    const minDate = new Date(today)
    maxDate.setDate(today.getDate() + 3)
    minDate.setMinutes(today.getMinutes() + 90)
    return { maxDate, minDate }
  }

  const selectedOwnStationTemplate = (option, props) => {
    if (option) {
      return option.centerName
    }
    return props.placeholder
  }

  const owStationOptionTemplate = (option) => option.centerName

  return (
    <>
      <LabeledDropdown
        idLabel="fuelStation"
        required
        value={inputs?.ownStation}
        valueTemplate={selectedOwnStationTemplate}
        options={fuelStationsOwn}
        name="ownStation"
        optionLabel="label"
        optionDisabled={(option) =>
          ownFuelStationDisabled.includes(option?._id)
        }
        itemTemplate={owStationOptionTemplate}
        onChange={(e) => onChangeInputs(e)}
        disabled={ownStationId}
      />
      <LabeledCalendar
        idLabel="change.date"
        name="changeDate"
        value={inputs?.changeDate}
        onChange={onChangeInputs}
        hourFormat="24"
        maxDate={getMaxDate()?.maxDate}
        minDate={getMaxDate()?.minDate}
        showTime
      />
    </>
  )
}

export default GasStationChangeDate
